import React from 'react';
import PropTypes from 'prop-types';
import { OnVisible } from '@americanexpress/data-manager-utils';
import MarketingTile from '../MarketingTile/MarketingTile';
import RenderEarlyTenureOrHomeTopColumnTile
  from '../RenderEarlyTenureOrHomeTopColumnTile/RenderEarlyTenureOrHomeTopColumnTile';

const DesktopSideTiles = ({
  topColumnTile, bottomColumnTile, cardType,
}) => (
  <>
    <div className="margin-4-b">
      <RenderEarlyTenureOrHomeTopColumnTile
        travelHomeTopColumnTileContent={topColumnTile}
        cardType={cardType}
      />
    </div>
    <div className="margin-4-b">
      <MarketingTile index={2} content={bottomColumnTile} />
    </div>
    <OnVisible
      analyticsInfo={{
        element: `hp-${cardType}`,
        detail: 'hp-tiles-L1-banner-hp-tiles-L2-banner',
      }}
    >
      <span />
    </OnVisible>
  </>
);

DesktopSideTiles.propTypes = {
  topColumnTile: PropTypes.shape({
    analyticIdentifier: PropTypes.string,
  }).isRequired,
  bottomColumnTile: PropTypes.shape({
    analyticIdentifier: PropTypes.string,
  }).isRequired,
  cardType: PropTypes.string.isRequired,
};

export default DesktopSideTiles;
